// extracted by mini-css-extract-plugin
export default {"convsBtn":"extraDataButton_convsBtn__rpoaa","personIcon":"extraDataButton_personIcon__AfjtX","convsBtnBadge":"extraDataButton_convsBtnBadge__eNVM8"};